/* VIP Sale 2026 – vip-gift.js (Eigentümer: T3, Stand 19.10.2026, v2: Auswahl im Modal statt im Drawer-Footer).
   Gratis-Teppich: Kompakt-Kachel im Warenkorb, Auswahl-Modal (Bottom-Sheet) an <body>, Hinweis unter dem Kasse-Button,
   PDP-Icon/-Button, Auto-Entfernen.
   Baut auf window.VIP (assets/vip-core.js) auf: phase(), cartBasisCents(), isGiftLine(), formatEUR(),
   onPhase(), onCart(), addItems(), updateCart(), changeLine(). Events: 'vip:phase', 'vip:cart' (document).

   Regeln (Board / Config-Vertrag):
   - Gratis-Teppich nur in Phasen mit gift=true. Berechtigt = VIP.cartBasisCents(cart) >= gift.threshold (Warenwert VOR Rabatt,
     _vip_gift-Zeilen zählen nicht mit).
   - Produktquelle = window.VIP_CONFIG.gift.product_handles (nur Varianten <= gift.max_value). Die Liste wird NIE hier erweitert.
     Produktdaten kommen über /products/<handle>.js (Shopify AJAX Product API), nicht über all_products (20-Lookup-Limit je Seite,
     auf Konfigurator-PDPs bereits fast ausgeschöpft). Geladen wird erst beim ersten Öffnen des Modals; Cache in sessionStorage.
     Sortierung im Modal: zuerst die großen Outdoor-Teppiche (Reihenfolge der Config), dann „Kinderteppiche“ (Titel beginnt mit
     „Kinderteppich“) unter einer Zwischenüberschrift.
   - Genau 1 Stück mit properties {_vip_gift: "true"}; maximal eine Gratis-Zeile (mehr -> auf 1 normalisiert). „ändern“ tauscht
     die Zeile (alte raus, neue rein).
   - Sinkt der Warenwert unter die Schwelle oder endet die Gift-Phase -> Gratis-Zeile(n) entfernen (einmal pro Zustand, Lock
     während laufender Requests) + Toast.
   - Shopify legt den Gratis-Artikel nie selbst in den Warenkorb und rechnet den Rabatt erst an der Kasse (automatischer BXGY-Rabatt,
     live ab 25.10. 07:00Z) -> das Theme zeigt nur „GRATIS“ + durchgestrichenen Preis.
   Das Modal hängt an <body> (wie das Savecart-Modal von T7): .drawer__inner hat ein transform und der Drawer-Footer ist nicht
   scrollbar – im Footer bleibt nur die ≈ 64–72 px hohe Kompakt-Kachel. Alle DOM-Inits sind idempotent (Warenkorb-Footer/-Zeilen
   werden vom Theme per innerHTML ersetzt); das Modal wird nie ersetzt. */
(function () {
  'use strict';
  if (window.VIPGift && window.VIPGift.__init) return;

  var CACHE_KEY = 'vip_gift_products_v2';
  var CACHE_TTL = 15 * 60 * 1000;
  var TOAST_MS = 7000;
  var ICON_FALLBACK = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false" class="vip-icon vip-icon-rug"><path d="M3.5 25h18.5"/><path d="M3.5 20.5h11.5"/><path d="M3.5 20.5v4.5"/><path d="M8 20.5v4.5M12.5 20.5v4.5" stroke-width="1.2" opacity=".55"/><path d="M3.5 25v2.4M6.2 25v2.4M8.9 25v2.4M11.6 25v2.4" stroke-width="1.2" opacity=".8"/><circle cx="22" cy="17.5" r="7.5"/><circle cx="22" cy="17.5" r="3.6"/><circle cx="22" cy="17.5" r=".7" fill="currentColor" stroke="none"/></svg>';

  var state = {
    removing: false,
    removeSig: null,
    adding: false,
    productsPromise: null,
    products: null
  };

  /* ---------- Helfer ---------- */
  function cfg() { return (window.VIP && VIP.config && VIP.config.gift) || {}; }
  function thresholdCents() { return Math.round((Number(cfg().threshold) || 1000) * 100); }
  function maxCents() { return Math.round((Number(cfg().max_value) || 129.9) * 100); }
  function giftProp() { return cfg().line_property || '_vip_gift'; }
  function handles() { return (cfg().product_handles || []).slice(); }
  function isRugHandle(h) { return !!h && handles().indexOf(h) > -1; }
  function phase() { return (window.VIP && VIP.phase()) || { gift: false, active: false, key: 'pre' }; }
  function giftActive(p) { return !!(p && p.active && p.gift); }
  function cart() { return (window.VIP && VIP.cart) || null; }
  function basis(c) { return window.VIP ? VIP.cartBasisCents(c || cart()) : 0; }
  function giftLines(c) {
    c = c || cart();
    if (!c || !c.items) return [];
    return c.items.filter(function (it) { return VIP.isGiftLine(it); });
  }
  function eligible(c) { return basis(c) >= thresholdCents(); }
  function eur(cents, short) {
    var v = (Number(cents) || 0) / 100;
    var whole = short && Math.abs(v - Math.round(v)) < 0.005;
    try {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 }).format(v);
    } catch (e) { return VIP.formatEUR(cents); }
  }
  function shortTitle(t) { return String(t || '').replace('In- & Outdoor-Teppich ', '').replace(' waschbar', '').trim(); }
  function isKids(p) { return /^kinderteppich/i.test(String(p.title || '')); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function show(el, on) { if (!el) return; if (on) el.removeAttribute('hidden'); else el.setAttribute('hidden', ''); }
  function setText(el, txt) { if (el) el.textContent = txt; }
  function imgUrl(url, w) {
    if (!url) return '';
    try { var u = new URL(url, window.location.origin); u.searchParams.set('width', String(w || 400)); return u.toString(); } catch (e) { return url; }
  }
  function escapeHtml(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function rugIcon() {
    var tpl = document.querySelector('[data-vip-gift] svg.vip-icon-rug, [data-vip-pdp-gift] svg.vip-icon-rug, [data-vip-gift-hint] svg.vip-icon-rug');
    return tpl ? tpl.outerHTML : ICON_FALLBACK;
  }
  function openDrawer() {
    var d = document.querySelector('cart-drawer');
    if (d && typeof d.show === 'function') { try { d.show(); return true; } catch (e) {} }
    if (d) { try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } })); return true; } catch (e) {} }
    window.location.href = (VIP.routes && VIP.routes().cart) || '/cart';
    return false;
  }
  function drawerIsOpen() {
    var d = document.querySelector('cart-drawer');
    return !!(d && (d.hasAttribute('open') || d.hasAttribute('active')));
  }
  function showError(msg) { qsa('[data-vip-gift-error], [data-vip-pdp-error]').forEach(function (e) { e.textContent = msg; show(e, true); }); }
  function clearErrors() { qsa('[data-vip-gift-error], [data-vip-pdp-error]').forEach(function (e) { show(e, false); }); }

  /* ---------- Toast ---------- */
  var toastEl = null, toastTimer = null;
  function toast(html) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'vip-gift-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '<span class="vip-gift-toast__icon">' + rugIcon() + '</span><span class="vip-gift-toast__text">' + html + '</span><button type="button" class="vip-gift-toast__close" aria-label="Schließen">×</button>';
    toastEl.querySelector('.vip-gift-toast__close').addEventListener('click', hideToast);
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, TOAST_MS);
  }
  function hideToast() { if (toastEl) toastEl.classList.remove('is-visible'); }

  /* ---------- Produktdaten (Handle-Liste aus vip-config) ---------- */
  function cacheSig() { return handles().join(',') + '|' + maxCents(); }
  function readCache() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || !obj.t || !obj.items || Date.now() - obj.t > CACHE_TTL) return null;
      if (obj.sig !== cacheSig()) return null;
      return obj.items;
    } catch (e) { return null; }
  }
  function writeCache(items) {
    try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), sig: cacheSig(), items: items })); } catch (e) {}
  }
  function normalizeProduct(p) {
    if (!p || !p.variants) return null;
    var max = maxCents();
    var variants = p.variants.filter(function (v) { return v.available && Number(v.price) <= max; }).map(function (v) {
      return { id: v.id, title: v.title, price: Number(v.price), compare: Number(v.compare_at_price) || 0, image: v.featured_image && v.featured_image.src };
    });
    if (!variants.length) return null;
    return { handle: p.handle, title: p.title, short: shortTitle(p.title), image: p.featured_image || (p.images && p.images[0]) || '', variants: variants };
  }
  function loadProducts() {
    if (state.products) return Promise.resolve(state.products);
    if (state.productsPromise) return state.productsPromise;
    var cached = readCache();
    if (cached) { state.products = cached; return Promise.resolve(cached); }
    // VIP.routes().root ist '/' (oder '/de' bei Locale-Pfaden) -> doppelte Slashes vermeiden ('//products' wäre protokoll-relativ!)
    var root = String((VIP.routes && VIP.routes().root) || '').replace(/\/+$/, '');
    var list = handles();
    state.productsPromise = Promise.all(list.map(function (h) {
      return window.fetch(root + '/products/' + encodeURIComponent(h) + '.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(normalizeProduct)
        .catch(function () { return null; });
    })).then(function (arr) {
      var items = arr.filter(Boolean);
      state.products = items;
      state.productsPromise = null;
      if (items.length) writeCache(items);
      return items;
    });
    return state.productsPromise;
  }

  /* ---------- Warenkorb-Aktionen ---------- */
  function addGift(variantId, btn, opts) {
    opts = opts || {};
    if (state.adding) return Promise.resolve();
    var existing = giftLines();
    if (existing.length && !opts.replace) return Promise.resolve();
    state.adding = true;
    clearErrors();
    qsa('[data-vip-gift]').forEach(function (r) { r.classList.add('is-busy'); });
    var props = {}; props[giftProp()] = 'true';
    if (btn) { btn.setAttribute('disabled', ''); btn.classList.add('is-loading'); var t = btn.querySelector('[data-vip-pdp-add-text], .vip-gift__add-text'); if (t) { t.setAttribute('data-prev', t.textContent); t.textContent = 'Wird hinzugefügt …'; } }
    var openAfter = !drawerIsOpen();
    var chain = Promise.resolve();
    if (existing.length) {
      var updates = {};
      existing.forEach(function (g) { updates[g.key] = 0; });
      chain = VIP.updateCart({ updates: updates });
    }
    return chain.then(function () {
      return VIP.addItems({ items: [{ id: Number(variantId), quantity: 1, properties: props }] }, { open: openAfter });
    }).catch(function (err) {
      showError((err && err.message) || 'Der Teppich konnte nicht hinzugefügt werden.');
    }).then(function () {
      state.adding = false;
      qsa('[data-vip-gift]').forEach(function (r) { r.classList.remove('is-busy'); });
      if (btn) { btn.removeAttribute('disabled'); btn.classList.remove('is-loading'); var t2 = btn.querySelector('[data-vip-pdp-add-text], .vip-gift__add-text'); if (t2 && t2.getAttribute('data-prev')) t2.textContent = t2.getAttribute('data-prev'); }
      update('after-add');
    });
  }
  /* Auto-Entfernen / Normalisieren – einmal pro Zustand, kein Loop.
     Phasenende: erst entfernen, wenn die Phase OHNE gift seit >= PHASE_GRACE_MS stabil ist (Core kann beim Wechsel
     early->vipday kurz 'post' liefern); Unterschreiten der Schwelle wird sofort entfernt. */
  var PHASE_GRACE_MS = 3000, phaseTimer = null;
  function cancelPhaseTimer() { if (phaseTimer) { clearTimeout(phaseTimer); phaseTimer = null; } }
  function maybeAutoRemove(c, p) {
    var gifts = giftLines(c);
    if (!gifts.length || state.removing || state.adding) { if (!gifts.length) cancelPhaseTimer(); return false; }
    var belowThreshold = !eligible(c);
    var phaseEnded = !giftActive(p);
    if (phaseEnded && !belowThreshold) {
      if (!phaseTimer) {
        phaseTimer = setTimeout(function () {
          phaseTimer = null;
          var c2 = cart(), p2 = phase();
          if (c2 && giftLines(c2).length && !giftActive(p2)) { state.removeSig = null; forceRemove(c2, p2); }
        }, PHASE_GRACE_MS);
      }
      return false;
    }
    cancelPhaseTimer();
    var removeAll = belowThreshold;
    var normalize = gifts.length > 1 || gifts[0].quantity !== 1;
    if (!removeAll && !normalize) return false;
    return doRemove(c, p, gifts, removeAll);
  }
  function forceRemove(c, p) { return doRemove(c, p, giftLines(c), true); }
  function doRemove(c, p, gifts, removeAll) {
    if (!gifts.length || state.removing || state.adding) return false;
    var sig = (c.token || '') + '|' + gifts.map(function (g) { return g.key + ':' + g.quantity; }).join(',') + '|' + (removeAll ? 'rm' : 'norm');
    if (sig === state.removeSig) return false;
    state.removeSig = sig;
    state.removing = true;
    var updates = {};
    gifts.forEach(function (g, i) { updates[g.key] = removeAll ? 0 : (i === 0 ? 1 : 0); });
    var reason = !giftActive(p) ? 'phase' : 'threshold';
    VIP.updateCart({ updates: updates }).then(function () {
      if (removeAll) {
        if (reason === 'threshold') toast('<strong>Dein Gratis-Teppich wurde entfernt</strong> – ab ' + eur(thresholdCents(), true) + ' Warenwert ist er wieder dabei.');
        else toast('<strong>Die Gratis-Teppich-Aktion ist beendet</strong> – dein Gratis-Teppich wurde aus dem Warenkorb entfernt.');
      }
    }).catch(function (e) { console.warn('[VIP gift] Entfernen fehlgeschlagen', e); }).then(function () { state.removing = false; update('after-remove'); });
    return true;
  }

  /* ---------- Auswahl-Modal (an <body>, über dem Drawer) ---------- */
  var modal = null, modalOpener = null, modalOpen = false;
  function ensureModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'vip-modal vip-gift-modal';
    modal.setAttribute('data-vip-gift-modal', '');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'vip-gift-modal-title');
    modal.setAttribute('hidden', '');
    modal.innerHTML =
      '<div class="vip-modal__overlay no-empty" data-vip-gift-close></div>' +
      '<div class="vip-gift-modal__panel" tabindex="-1">' +
        '<div class="vip-gift-modal__head">' +
          '<span class="vip-gift-modal__icon" aria-hidden="true">' + rugIcon() + '</span>' +
          '<div class="vip-gift-modal__head-text">' +
            '<h2 class="vip-gift-modal__title" id="vip-gift-modal-title">Wähle deinen Gratis-Teppich</h2>' +
            '<p class="vip-gift-modal__sub">1 Teppich bis <span data-vip-gift-max>' + eur(maxCents()) + '</span> nach Wahl</p>' +
          '</div>' +
          '<button type="button" class="vip-modal__close vip-gift-modal__close" data-vip-gift-close aria-label="Schließen">×</button>' +
        '</div>' +
        '<div class="vip-gift-modal__body" data-vip-gift-modal-body>' +
          '<p class="vip-gift__loading">Teppiche werden geladen …</p>' +
        '</div>' +
        '<p class="vip-gift__error vip-pill vip-pill--soft vip-gift-modal__error" data-vip-gift-error hidden></p>' +
      '</div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-vip-gift-close]')) { e.preventDefault(); closeModal(); return; }
      var add = e.target.closest('[data-vip-gift-add]');
      if (add && !add.hasAttribute('disabled')) {
        e.preventDefault();
        var tile = add.closest('[data-vip-gift-tile]');
        var sel = tile && tile.querySelector('[data-vip-gift-variant]');
        if (!sel || !sel.value) return;
        if (!eligible() || !giftActive(phase())) { closeModal(); update('stale-click'); return; }
        var current = giftLines()[0];
        closeModal();
        addGift(sel.value, null, { replace: !!current });
      }
    });
    modal.addEventListener('change', function (e) {
      var sel = e.target.closest('select[data-vip-gift-variant]');
      if (!sel) return;
      var tile = sel.closest('[data-vip-gift-tile]');
      var opt = sel.options[sel.selectedIndex];
      var priceEl = tile && tile.querySelector('[data-vip-gift-price]');
      if (priceEl && opt) priceEl.textContent = eur(opt.getAttribute('data-price'));
      syncCurrentTile(tile);
    });
    document.addEventListener('keydown', function (e) { if (modalOpen && (e.key === 'Escape' || e.key === 'Esc')) { e.preventDefault(); closeModal(); } });
    return modal;
  }
  function syncCurrentTile(tile) {
    var current = giftLines()[0];
    var sel = tile.querySelector('[data-vip-gift-variant]');
    var btn = tile.querySelector('[data-vip-gift-add]');
    var isCurrent = !!(current && sel && Number(sel.value) === Number(current.variant_id));
    tile.classList.toggle('is-current', isCurrent);
    if (btn) {
      if (isCurrent) { btn.setAttribute('disabled', ''); btn.innerHTML = '<span class="vip-gift__add-text">Dein Teppich ✓</span>'; }
      else { btn.removeAttribute('disabled'); btn.innerHTML = '<span class="vip-gift__add-text">Auswählen</span>'; }
    }
  }
  function tileHtml(p) {
    var first = p.variants[0];
    var sizeHtml;
    if (p.variants.length > 1) {
      sizeHtml = '<label class="vip-gift-modal__size"><span class="visually-hidden">Größe</span><select class="vip-gift-modal__select" data-vip-gift-variant aria-label="Größe wählen">' +
        p.variants.map(function (v) { return '<option value="' + v.id + '" data-price="' + v.price + '">' + escapeHtml(v.title) + '</option>'; }).join('') + '</select></label>';
    } else {
      sizeHtml = '<input type="hidden" data-vip-gift-variant value="' + first.id + '" data-price="' + first.price + '">' +
        (first.title && first.title !== 'Default Title' ? '<span class="vip-gift-modal__size-text">' + escapeHtml(first.title) + '</span>' : '');
    }
    return '<div class="vip-gift-modal__tile" role="listitem" data-vip-gift-tile data-handle="' + escapeHtml(p.handle) + '">' +
      '<div class="vip-gift-modal__media">' + (p.image ? '<img src="' + escapeHtml(imgUrl(p.image, 300)) + '" alt="' + escapeHtml(p.short) + '" loading="lazy" width="300" height="300">' : '') + '<span class="vip-gift-modal__badge">GRATIS</span></div>' +
      '<div class="vip-gift-modal__tbody">' +
        '<span class="vip-gift-modal__name">' + escapeHtml(p.short) + '</span>' + sizeHtml +
        '<span class="vip-gift-modal__price"><s data-vip-gift-price>' + eur(first.price) + '</s><span class="vip-gift-modal__arrow" aria-hidden="true">→</span><span class="vip-gift-modal__free">GRATIS</span></span>' +
        '<button type="button" class="vip-btn vip-btn--accent vip-btn--small vip-btn--block vip-gift-modal__add" data-vip-gift-add><span class="vip-gift__add-text">Auswählen</span></button>' +
      '</div></div>';
  }
  function renderModalBody() {
    var body = modal.querySelector('[data-vip-gift-modal-body]');
    body.setAttribute('aria-busy', 'true');
    loadProducts().then(function (items) {
      body.setAttribute('aria-busy', 'false');
      if (!items.length) { body.innerHTML = '<p class="vip-gift__empty">Gerade ist kein Gratis-Teppich verfügbar – schau gleich nochmal vorbei.</p>'; return; }
      var outdoor = items.filter(function (p) { return !isKids(p); });
      var kids = items.filter(isKids);
      var html = '';
      if (outdoor.length) html += '<h3 class="vip-gift-modal__subhead vip-gift-modal__subhead--first">Outdoor-Teppiche</h3><div class="vip-gift-modal__grid" role="list">' + outdoor.map(tileHtml).join('') + '</div>';
      if (kids.length) html += '<h3 class="vip-gift-modal__subhead">Kinderteppiche</h3><div class="vip-gift-modal__grid" role="list">' + kids.map(tileHtml).join('') + '</div>';
      body.innerHTML = html;
      qsa('[data-vip-gift-tile]', body).forEach(syncCurrentTile);
    });
  }
  function openModal(opener) {
    ensureModal();
    modalOpener = opener || document.activeElement;
    setText(modal.querySelector('[data-vip-gift-max]'), eur(maxCents()));
    show(modal.querySelector('[data-vip-gift-error]'), false);
    renderModalBody();
    modal.removeAttribute('hidden');
    modalOpen = true;
    document.documentElement.classList.add('vip-gift-modal-open');
    var panel = modal.querySelector('.vip-gift-modal__panel');
    panel.scrollTop = 0;
    var b = modal.querySelector('[data-vip-gift-modal-body]'); if (b) b.scrollTop = 0;
    try { modal.querySelector('.vip-gift-modal__close').focus({ preventScroll: true }); } catch (e) {}
  }
  function closeModal() {
    if (!modal || !modalOpen) return;
    modal.setAttribute('hidden', '');
    modalOpen = false;
    document.documentElement.classList.remove('vip-gift-modal-open');
    if (modalOpener && modalOpener.isConnected && typeof modalOpener.focus === 'function') { try { modalOpener.focus({ preventScroll: true }); } catch (e) {} }
    modalOpener = null;
  }

  /* ---------- Warenkorb: Kompakt-Kachel ---------- */
  function initCartRoots(c, p) {
    var roots = qsa('[data-vip-gift]');
    if (!roots.length) return;
    var gifts = giftLines(c);
    var active = giftActive(p);
    var ok = eligible(c);
    roots.forEach(function (root) {
      var cta = root.querySelector('[data-vip-gift-cta]');
      var chosen = root.querySelector('[data-vip-gift-chosen]');
      setText(root.querySelector('[data-vip-gift-threshold]'), eur(thresholdCents(), true));
      setText(root.querySelector('[data-vip-gift-max]'), eur(maxCents()));
      if (!active || (!gifts.length && !ok)) { show(root, false); show(cta, false); show(chosen, false); return; }
      show(root, true);
      if (gifts.length) {
        show(chosen, true); show(cta, false);
        var g = gifts[0];
        // DOM kann älter sein als der Warenkorb (Re-Render läuft) -> Name/Thumb aus dem Cart-JSON synchronisieren
        if (String(root.getAttribute('data-vip-gift-line-variant')) !== String(g.variant_id)) {
          var name = shortTitle(g.product_title) + (g.variant_title && g.variant_title !== 'Default Title' ? ' · ' + String(g.variant_title).replace(/cm$/i, '') : '');
          setText(root.querySelector('[data-vip-gift-chosen-name]'), name);
          var nameEl = root.querySelector('[data-vip-gift-chosen-name]'); if (nameEl) nameEl.setAttribute('title', name);
          var thumb = root.querySelector('[data-vip-gift-chosen-thumb]');
          if (thumb && g.image) thumb.innerHTML = '<img src="' + escapeHtml(imgUrl(g.image, 120)) + '" alt="" width="44" height="44" loading="lazy">';
          root.setAttribute('data-vip-gift-line-variant', String(g.variant_id));
        }
      } else {
        show(chosen, false); show(cta, true);
      }
    });
  }

  /* ---------- Warenkorb-Zeile der Gratis-Position markieren (GRATIS + Hinweis) ---------- */
  function markGiftLines(c) {
    var gifts = giftLines(c);
    qsa('.cart-item.vip-gift-line').forEach(function (row) {
      var idx = Number(row.getAttribute('data-vip-gift-index'));
      var it = c && c.items && c.items[idx - 1];
      if (!it || !VIP.isGiftLine(it)) {
        row.classList.remove('vip-gift-line');
        qsa('.vip-gift-line__badge', row).forEach(function (b) { b.remove(); });
      }
    });
    if (!c || !c.items || !gifts.length) return;
    c.items.forEach(function (it, i) {
      if (!VIP.isGiftLine(it)) return;
      var idx = i + 1;
      qsa('#CartDrawer-Item-' + idx + ', #CartItem-' + idx).forEach(function (row) {
        var vid = row.getAttribute('data-variant-id');
        if (vid && Number(vid) !== Number(it.variant_id)) return; // DOM noch nicht neu gerendert
        row.classList.add('vip-gift-line');
        row.setAttribute('data-vip-gift-index', String(idx));
        qsa('.cart-item__prices', row).forEach(function (pr) {
          if (pr.querySelector('.vip-gift-line__badge')) return;
          var b = document.createElement('span');
          b.className = 'vip-gift-line__badge';
          b.innerHTML = '<strong>GRATIS</strong>';
          pr.appendChild(b);
        });
      });
    });
  }

  /* ---------- Hinweis unter dem Kasse-Button ---------- */
  function initHints(c, p) {
    var roots = qsa('[data-vip-gift-hint]');
    if (!roots.length) return;
    var active = giftActive(p);
    var gifts = giftLines(c);
    var b = basis(c), th = thresholdCents();
    roots.forEach(function (root) {
      if (!active || !c || !c.item_count) { show(root, false); return; }
      show(root, true);
      var prog = root.querySelector('[data-vip-gift-hint-progress]');
      var done = root.querySelector('[data-vip-gift-hint-done]');
      var pick = root.querySelector('[data-vip-gift-hint-pick]');
      setText(root.querySelector('[data-vip-gift-hint-max]'), eur(maxCents()));
      var scrollBtn = root.querySelector('[data-vip-gift-scroll]');
      if (scrollBtn) scrollBtn.textContent = 'jetzt auswählen'; // öffnet das Modal (Handler unten)
      // Ab der Schwelle zeigt die Kompakt-Kachel (vip-cart-gift) über dem Kasse-Button bereits CTA bzw. Status –
      // der Hinweis darunter wäre doppelt und kostet Footer-Höhe; er bleibt nur als Fallback, wenn keine Kachel sichtbar ist.
      var tileVisible = !!document.querySelector('[data-vip-gift]:not([hidden])');
      if (gifts.length) { show(done, !tileVisible); show(prog, false); show(pick, false); show(root, !tileVisible); }
      else if (b >= th) { show(done, false); show(prog, false); show(pick, !tileVisible); show(root, !tileVisible); }
      else {
        show(done, false); show(pick, false); show(prog, true);
        setText(root.querySelector('[data-vip-gift-hint-missing]'), eur(th - b));
        var pct = Math.max(0, Math.min(100, Math.round(b / th * 100)));
        var bar = root.querySelector('[data-vip-gift-hint-bar]');
        if (bar) { bar.style.setProperty('--vip-percent', pct + '%'); bar.setAttribute('aria-valuenow', String(pct)); }
      }
    });
  }

  /* ---------- PDP ---------- */
  function pdpSelectedVariant(root) {
    var form = document.getElementById(root.getAttribute('data-form-id') || '');
    var input = form && form.querySelector('input[name="id"], select[name="id"]');
    var id = input && input.value ? Number(input.value) : Number(root.getAttribute('data-selected-variant'));
    var map = {};
    String(root.getAttribute('data-variants') || '').split(';').forEach(function (pair) {
      var kv = pair.split(':'); if (kv.length === 2 && kv[0]) map[Number(kv[0])] = Number(kv[1]);
    });
    return { id: id, price: map[id] };
  }
  function pdpPriceOverlay(root, on) {
    var sec = root.getAttribute('data-section-id');
    var wrap = sec && document.getElementById('price-' + sec);
    if (!wrap) return;
    wrap.classList.toggle('vip-gift-free', !!on);
    var price = wrap.querySelector('.f-price');
    var badge = wrap.querySelector('.vip-pdp-gift__free-badge');
    if (on) {
      if (!badge && price) {
        badge = document.createElement('span');
        badge.className = 'vip-pdp-gift__free-badge';
        badge.innerHTML = '<strong>GRATIS</strong>';
        price.appendChild(badge);
      }
    } else if (badge) {
      badge.remove();
    }
  }
  function initPdp(c, p) {
    var roots = qsa('[data-vip-pdp-gift]');
    if (!roots.length) return;
    var active = giftActive(p);
    var gifts = giftLines(c);
    var b = basis(c), th = thresholdCents(), ok = b >= th;
    roots.forEach(function (root) {
      if (!active) { show(root, false); pdpPriceOverlay(root, false); return; }
      show(root, true);
      var hint = root.querySelector('[data-vip-pdp-hint]');
      show(hint, true);
      setText(root.querySelector('[data-vip-pdp-max]'), eur(maxCents()));
      var states = { progress: root.querySelector('[data-vip-pdp-state="progress"]'), pick: root.querySelector('[data-vip-pdp-state="pick"]'), done: root.querySelector('[data-vip-pdp-state="done"]') };
      // „aussuchen“ auf der PDP öffnet direkt das Auswahl-Modal (statt nur den Drawer)
      var pickBtn = states.pick && states.pick.querySelector('[data-vip-pdp-open-cart]');
      if (pickBtn) { pickBtn.removeAttribute('data-vip-pdp-open-cart'); pickBtn.setAttribute('data-vip-gift-open', ''); pickBtn.textContent = 'jetzt aussuchen'; }
      var handle = root.getAttribute('data-product-handle');
      var rug = isRugHandle(handle);
      var rugBox = root.querySelector('[data-vip-pdp-rug]');
      var sel = pdpSelectedVariant(root);
      var selOk = rug && sel.price != null && sel.price <= maxCents();
      var isMine = gifts.length && Number(gifts[0].variant_id) === Number(sel.id);

      if (gifts.length) { show(states.done, true); show(states.pick, false); show(states.progress, false); }
      else if (ok) { show(states.pick, !rug || !selOk); show(states.done, false); show(states.progress, false); }
      else { show(states.progress, true); show(states.pick, false); show(states.done, false); setText(root.querySelector('[data-vip-pdp-missing]'), eur(th - b)); }
      if (ok && rug && selOk && !gifts.length) show(hint, false); // der Button unten sagt alles

      // Teppich-PDP: Button + Preis-Overlay
      if (!rug || !rugBox) { show(rugBox, false); pdpPriceOverlay(root, false); }
      else {
        var btn = rugBox.querySelector('[data-vip-pdp-add]');
        var txt = rugBox.querySelector('[data-vip-pdp-add-text]');
        var note = rugBox.querySelector('[data-vip-pdp-rug-note]');
        show(rugBox, ok);
        if (!ok) { pdpPriceOverlay(root, false); }
        else if (!selOk) {
          btn.setAttribute('disabled', ''); setText(txt, 'Als Gratis-Teppich hinzufügen');
          note.innerHTML = 'Diese Größe ist nicht als Gratis-Teppich wählbar (gratis sind Größen bis ' + eur(maxCents()) + ').';
          pdpPriceOverlay(root, false);
        } else if (isMine) {
          btn.setAttribute('disabled', ''); setText(txt, 'Das ist dein Gratis-Teppich ✓');
          note.innerHTML = 'Liegt bereits als Gratis-Teppich in deinem Warenkorb · <button type="button" class="vip-link" data-vip-pdp-open-cart>Warenkorb ansehen</button>';
          pdpPriceOverlay(root, true);
        } else if (gifts.length) {
          btn.setAttribute('disabled', ''); setText(txt, 'Gratis-Teppich schon gewählt');
          note.innerHTML = 'Du hast bereits <strong>' + escapeHtml(shortTitle(gifts[0].product_title)) + '</strong> als Gratis-Teppich gewählt · <button type="button" class="vip-link" data-vip-gift-open>Auswahl ändern</button>';
          pdpPriceOverlay(root, false);
        } else {
          btn.removeAttribute('disabled'); setText(txt, 'Als Gratis-Teppich hinzufügen');
          note.innerHTML = 'Du hast die ' + eur(th, true) + ' geknackt – dieser Teppich ist für dich <strong>gratis</strong>.';
          pdpPriceOverlay(root, true);
        }
      }
      if (!root.__vipBound) {
        root.__vipBound = true;
        root.addEventListener('click', function (e) {
          var open = e.target.closest('[data-vip-pdp-open-cart]');
          if (open) { e.preventDefault(); openDrawer(); return; }
          var add = e.target.closest('[data-vip-pdp-add]');
          if (add && !add.hasAttribute('disabled')) {
            e.preventDefault();
            var v = pdpSelectedVariant(root);
            if (!v.id || v.price == null || v.price > maxCents() || !eligible() || !giftActive(phase()) || giftLines().length) { update('stale-click'); return; }
            show(root.querySelector('[data-vip-pdp-error]'), false);
            addGift(v.id, add);
          }
        });
      }
    });
  }

  /* ---------- Gesamt-Update ---------- */
  var updateTimer = null;
  function update(source) {
    var c = cart(), p = phase();
    if (c && maybeAutoRemove(c, p)) { /* nach dem Entfernen kommt ein neues vip:cart */ }
    initCartRoots(c, p);
    markGiftLines(c);
    initHints(c, p);
    initPdp(c, p);
    // Modal offen, aber Berechtigung/Phase weg -> schließen
    if (modalOpen && (!giftActive(p) || !eligible(c))) closeModal();
  }
  function scheduleUpdate(source) {
    clearTimeout(updateTimer);
    updateTimer = setTimeout(function () { update(source); }, 30);
  }

  function boot() {
    if (!window.VIP || !VIP.__core) { setTimeout(boot, 50); return; }
    VIP.onPhase(function (p) { if (giftActive(p)) cancelPhaseTimer(); scheduleUpdate('phase'); });
    VIP.onCart(function () { scheduleUpdate('cart'); });
    document.addEventListener('variant:changed', function () { scheduleUpdate('variant'); });
    document.addEventListener('change', function (e) { if (e.target && e.target.name === 'id' && e.target.closest('form[is="product-form"]')) scheduleUpdate('variant-input'); });
    // Theme ersetzt Warenkorb-DOM nach eigenen Requests; vip:cart kommt danach – zur Sicherheit auch auf cart:updated reagieren
    document.addEventListener('cart:updated', function () { scheduleUpdate('theme'); });
    document.addEventListener('cart:refresh', function () { scheduleUpdate('refresh'); });
    // Delegiert (Warenkorb-DOM wird ersetzt): Modal öffnen aus Kompakt-Kachel („Auswählen“/„ändern“), Hinweis und PDP
    document.addEventListener('click', function (e) {
      var o = e.target.closest('[data-vip-gift-open], [data-vip-gift-change], [data-vip-gift-scroll]');
      if (!o || (modal && modal.contains(o))) return;
      e.preventDefault();
      if (!eligible() || !giftActive(phase())) { update('stale-click'); return; }
      openModal(o);
    });
    scheduleUpdate('boot');
  }

  window.VIPGift = { __init: true, update: update, loadProducts: loadProducts, addGift: addGift, openModal: openModal, closeModal: closeModal, state: state };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
